export default __webpack_public_path__ + "static/media/daily_goal_target.261658a0.png";